export default "__VITE_ASSET__DokyIKC2__"